import React, { useEffect, useRef } from 'react';
import { Row, Col } from 'antd';

import { VideoContainer } from './styles';

interface VideoProps {
	url: string;
	frame?: number;
	fileName: string;
}

export function Video({ url, frame = 10, fileName }: Readonly<VideoProps>) {
	const videoRef = useRef<HTMLVideoElement>(null);

	useEffect(() => {
		function handleSetCurrentTime(): void {
			if (videoRef?.current && url) {
				videoRef.current.currentTime = frame;
			}
		}

		if (videoRef?.current) {
			if (videoRef.current.readyState >= 2) {
				handleSetCurrentTime();
			} else {
				const handleLoadedMetadata = () => {
					handleSetCurrentTime();
					videoRef.current?.removeEventListener('loadedmetadata', handleLoadedMetadata);
				};
				videoRef.current.addEventListener('loadedmetadata', handleLoadedMetadata);
			}
		}
	}, [url, frame]);

	return (
		<Row style={{ position: 'relative' }}>
			<Col span={24}>
				<VideoContainer>
					<video width="100%" height="100%" ref={videoRef} preload="metadata" title={fileName}>
						<source src={url} type="video/webm" />
						<source src={url} type="video/mp4" />
						Your browser does not support the video tag.
					</video>
				</VideoContainer>
			</Col>
		</Row>
	);
}
